// extracted by mini-css-extract-plugin
export var cardHeader = "_sd-0";
export var reorderHandle = "_sd-3";
export var titleArea = "_sd-1";
export var titleAreaWithHandle = "_sd-2";